import React, { lazy, useEffect } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { InferredProjectsLoadingShell } from '../../pages/inferred-projects/components/LoadingStates';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const InferredProjectsPage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-inferred-projects" */ '../../pages/inferred-projects'
		),
);

const InferredProjectsRouteFallback = (): React.JSX.Element | null => (
	<InferredProjectsLoadingShell />
);

const InferredProjectsPageWithAccess: React.FC = () => {
	return (
		<AppAccessGate appName="Labs" fallback={<InferredProjectsLoadingShell />}>
			<InferredProjectsPage />
		</AppAccessGate>
	);
};

const ROUTE_PREFIX = '/workstreams' as const;
const LEGACY_ROUTE_PREFIX = '/inferred-projects' as const;

const LegacyRedirect: React.FC = () => {
	useEffect(() => {
		window.history.replaceState(
			{},
			'',
			`${ROUTE_PREFIX}${window.location.search}${window.location.hash}`,
		);
		window.dispatchEvent(new PopStateEvent('popstate'));
	}, []);

	return null;
};

const inferredProjectsRoutesObject: Record<string, Route> = {
	home: {
		name: 'inferred-projects',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(
			InferredProjectsPageWithAccess,
			<InferredProjectsRouteFallback />,
		),
	},
	legacy: {
		name: 'inferred-projects-legacy',
		path: LEGACY_ROUTE_PREFIX,
		exact: true,
		component: LegacyRedirect,
	},
};

export const inferredProjectsRoutes: Routes = Object.values(inferredProjectsRoutesObject);
